import { IFilter } from "@saleor/components/Filter";
import { FilterOpts } from "@saleor/types";
import { createOptionsField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export interface MallShippingLogsFilterOpts {
  event?: FilterOpts<string | string>;
}

export enum MallShippingLogsFilterKeys {
  event = "event"
}

const messages = defineMessages({
  event: {
    defaultMessage: "Event",
    description: "event"
  },
  eventCutoffTime: {
    defaultMessage: "Cutoff Time Changed",
    description: "event"
  },
  eventEndTime: {
    defaultMessage: "End Time Changed",
    description: "event"
  },
  eventSddDisabled: {
    defaultMessage: "Same Day Delivery Disabled",
    description: "event"
  },
  eventSddEnabled: {
    defaultMessage: "Same Day Delivery Enabled",
    description: "event"
  },
  eventStartTime: {
    defaultMessage: "Start Time Changed",
    description: "event"
  }
});

const eventOption = (intl, opts) => ({
  ...createOptionsField(
    MallShippingLogsFilterKeys.event,
    intl.formatMessage(messages.event),
    [opts?.event?.value],
    false,
    [
      {
        label: intl.formatMessage(messages.eventSddEnabled),
        value: "shipping method was enabled"
      },
      {
        label: intl.formatMessage(messages.eventSddDisabled),
        value: "shipping method was disabled"
      },
      {
        label: intl.formatMessage(messages.eventStartTime),
        value: "start time"
      },
      {
        label: intl.formatMessage(messages.eventEndTime),
        value: "end time"
      },
      {
        label: intl.formatMessage(messages.eventCutoffTime),
        value: "cutofftime"
      }
    ]
  ),
  active: opts?.event?.active
});

export function createFilterStructure(
  intl: IntlShape,
  opts: MallShippingLogsFilterOpts
): IFilter<MallShippingLogsFilterKeys> {
  return [eventOption(intl, opts)];
}
